import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://swadvedamasalasbe.onrender.com/api";

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);

  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    price: "",
    category: "",
    description: "",
    image: null
  });

  // =========================
  // FETCH PRODUCTS
  // =========================
  const fetchProducts = async () => {
    try {

      setTableLoading(true);

      const res = await axios.get(`${API_URL}/products`);

      setProducts(res.data);

    } catch (err) {

      console.error(err);

    } finally {

      setTableLoading(false);

    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // =========================
  // INPUT CHANGE
  // =========================
  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  // =========================
  // FORM VALIDATION
  // =========================
  const isFormValid =
    form.name &&
    form.price &&
    form.category &&
    form.description &&
    form.image;

  // =========================
  // ADD PRODUCT
  // =========================
  const addProduct = async () => {

    try {

      setLoading(true);

      const token = localStorage.getItem("token");

      const formData = new FormData();

      formData.append("name", form.name);
      formData.append("price", form.price);
      formData.append("category", form.category);
      formData.append("description", form.description);
      formData.append("image", form.image);

      await axios.post(
        `${API_URL}/admin/products`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      fetchProducts();

      setForm({
        name: "",
        price: "",
        category: "",
        description: "",
        image: null
      });

    } catch (err) {

      console.error("ADD ERROR:", err);

    } finally {

      setLoading(false);

    }
  };

  // =========================
  // DELETE PRODUCT
  // =========================
  const deleteProduct = async (id) => {

    try {

      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.delete(
        `${API_URL}/admin/products/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      fetchProducts();

    } catch (err) {

      console.error("DELETE ERROR:", err);

    } finally {

      setLoading(false);

    }
  };

  // =========================
  // OPEN EDIT
  // =========================
  const openEdit = (product) => {

    setEditingProduct(product);

    setForm({
      name: product.name || "",
      price: product.price || "",
      category: product.category || "",
      description: product.description || "",
      image: null
    });

  };

  // =========================
  // UPDATE PRODUCT
  // =========================
  // =========================
// UPDATE PRODUCT
// =========================
const updateProduct = async () => {

  try {

    setLoading(true);

    const token = localStorage.getItem("token");

    // =========================
    // IF IMAGE EXISTS
    // =========================
    if (form.image) {

      const formData = new FormData();

      formData.append("name", form.name);
      formData.append("price", form.price);
      formData.append("category", form.category);
      formData.append("description", form.description);
      formData.append("image", form.image);

      await axios.put(
        `${API_URL}/admin/products/${editingProduct._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

    } else {

      // =========================
      // NORMAL UPDATE
      // =========================
      await axios.put(
        `${API_URL}/admin/products/${editingProduct._id}`,
        {
          name: form.name,
          price: Number(form.price),
          category: form.category,
          description: form.description
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

    }

    setEditingProduct(null);

    setForm({
      name: "",
      price: "",
      category: "",
      description: "",
      image: null
    });

    fetchProducts();

  } catch (err) {

    console.error(
      "UPDATE ERROR:",
      err.response?.data || err
    );

  } finally {

    setLoading(false);

  }

};

  return (
    <div style={styles.container}>

      <div style={styles.pageHeader}>
        <h1 style={styles.heading}>
          Product Management
        </h1>

        <p style={styles.subHeading}>
          Add, edit and manage all products
        </p>
      </div>

      {/* ADD PRODUCT */}
      <div style={styles.card}>

        <h3 style={styles.sectionTitle}>
          Add New Product
        </h3>

        <div style={styles.formGrid}>

          <input
            name="name"
            placeholder="Product Name"
            value={form.name}
            onChange={handleChange}
            style={styles.input}
          />

          <input
            name="price"
            placeholder="Price"
            value={form.price}
            onChange={handleChange}
            style={styles.input}
          />

          <input
            name="category"
            placeholder="Category"
            value={form.category}
            onChange={handleChange}
            style={styles.input}
          />

          <input
            name="description"
            placeholder="Description"
            value={form.description}
            onChange={handleChange}
            style={styles.input}
          />

        </div>

        {/* FILE INPUT */}
        <div style={styles.uploadBox}>

          <label style={styles.uploadLabel}>
            Upload Product Image
          </label>

          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setForm({
                ...form,
                image: e.target.files[0]
              })
            }
          />

        </div>

        {/* PREVIEW */}
        {form.image && (
          <div style={styles.previewWrapper}>

            <img
              src={URL.createObjectURL(form.image)}
              alt="preview"
              style={styles.previewImage}
            />

          </div>
        )}

        <button
          onClick={addProduct}
          disabled={!isFormValid || loading}
          style={{
            ...styles.primaryButton,
            opacity:
              !isFormValid || loading
                ? 0.6
                : 1
          }}
        >
          {loading ? "Adding..." : "Add Product"}
        </button>

      </div>

      {/* TABLE */}
      {tableLoading ? (

        <div style={styles.loader}></div>

      ) : (

        <div style={styles.tableWrapper}>

          <table style={styles.table}>

            <thead>

              <tr style={styles.tableHeadRow}>
                <th style={styles.th}>Image</th>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>Price</th>
                <th style={styles.th}>Category</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}>Actions</th>
              </tr>

            </thead>

            <tbody>

              {products.map((p) => (

                <tr key={p._id} style={styles.tr}>

                  <td style={styles.td}>
                    <img
                      src={
                        p.image?.startsWith("http")
                          ? p.image
                          : "https://via.placeholder.com/80"
                      }
                      alt={p.name}
                      style={styles.image}
                    />
                  </td>

                  <td style={styles.td}>
                    {p.name}
                  </td>

                  <td style={styles.td}>
                    ₹{p.price}
                  </td>

                  <td style={styles.td}>
                    {p.category}
                  </td>

                  <td style={styles.td}>
                    {p.description}
                  </td>

                  <td style={styles.td}>

                    <button
                      disabled={loading}
                      onClick={() => openEdit(p)}
                      style={styles.editBtn}
                    >
                      Edit
                    </button>

                    <button
                      disabled={loading}
                      onClick={() => deleteProduct(p._id)}
                      style={styles.deleteBtn}
                    >
                      {loading
                        ? "Deleting..."
                        : "Delete"}
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      )}

      {/* EDIT MODAL */}
      {editingProduct && (

        <div style={styles.modalOverlay}>

          <div style={styles.modalCard}>

            {/* HEADER */}
            <div style={styles.modalHeader}>

              <h2 style={{ margin: 0 }}>
                Edit Product
              </h2>

              <button
                onClick={() =>
                  setEditingProduct(null)
                }
                style={styles.closeBtn}
              >
                ✕
              </button>

            </div>

            {/* IMAGE */}
            <div style={styles.previewWrapper}>

              <img
                src={
                  form.image
                    ? URL.createObjectURL(form.image)
                    : editingProduct.image
                }
                alt="preview"
                style={styles.modalImage}
              />

            </div>

            {/* FORM */}
            <div style={styles.modalForm}>

              <input
                name="name"
                placeholder="Product Name"
                value={form.name}
                onChange={handleChange}
                style={styles.input}
              />

              <input
                name="price"
                placeholder="Price"
                value={form.price}
                onChange={handleChange}
                style={styles.input}
              />

              <input
                name="category"
                placeholder="Category"
                value={form.category}
                onChange={handleChange}
                style={styles.input}
              />

              <textarea
                name="description"
                placeholder="Description"
                value={form.description}
                onChange={handleChange}
                style={styles.textarea}
              />

              {/* CHANGE IMAGE */}
              <div style={styles.uploadBox}>

                <label style={styles.uploadLabel}>
                  Change Product Image
                </label>

                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      image: e.target.files[0]
                    })
                  }
                />

              </div>

            </div>

            {/* FOOTER */}
            <div style={styles.modalFooter}>

              <button
                onClick={() =>
                  setEditingProduct(null)
                }
                style={styles.cancelBtn}
              >
                Cancel
              </button>

              <button
                onClick={updateProduct}
                style={styles.updateBtn}
              >
                {loading
                  ? "Updating..."
                  : "Update Product"}
              </button>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

// =========================
// STYLES
// =========================
const styles = {

  container: {
    padding: "30px",
    background: "#f4f6f9",
    minHeight: "100vh"
  },

  pageHeader: {
    marginBottom: "25px"
  },

  heading: {
    margin: 0,
    fontSize: "34px",
    fontWeight: "700"
  },

  subHeading: {
    color: "#666",
    marginTop: "8px"
  },

  card: {
    background: "#fff",
    padding: "24px",
    borderRadius: "20px",
    marginBottom: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)"
  },

  sectionTitle: {
    marginBottom: "20px"
  },

  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: "16px"
  },

  input: {
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none"
  },

  textarea: {
    minHeight: "100px",
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    resize: "none",
    fontSize: "14px"
  },

  uploadBox: {
    marginTop: "20px",
    padding: "18px",
    border: "2px dashed #ccc",
    borderRadius: "14px",
    background: "#fafafa"
  },

  uploadLabel: {
    display: "block",
    marginBottom: "10px",
    fontWeight: "600"
  },

  previewWrapper: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center"
  },

  previewImage: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "12px"
  },

  modalImage: {
    width: "130px",
    height: "130px",
    objectFit: "cover",
    borderRadius: "16px"
  },

  primaryButton: {
    marginTop: "20px",
    background: "#000",
    color: "#fff",
    border: "none",
    padding: "14px 20px",
    borderRadius: "12px",
    cursor: "pointer",
    fontWeight: "600"
  },

  tableWrapper: {
    background: "#fff",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  tableHeadRow: {
    background: "#000",
    color: "#fff"
  },

  th: {
    padding: "18px",
    textAlign: "left"
  },

  td: {
    padding: "18px",
    borderBottom: "1px solid #eee"
  },

  tr: {
    transition: "0.2s"
  },

  image: {
    width: "70px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "10px"
  },

  editBtn: {
    background: "#000",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "8px",
    marginRight: "10px",
    cursor: "pointer"
  },

  deleteBtn: {
    background: "#e53935",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "8px",
    cursor: "pointer"
  },

  loader: {
    border: "5px solid #f3f3f3",
    borderTop: "5px solid #000",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    margin: "50px auto",
    animation: "spin 1s linear infinite"
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
  },

  modalCard: {
    width: "500px",
    background: "#fff",
    borderRadius: "20px",
    padding: "25px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px"
  },

  closeBtn: {
    border: "none",
    background: "#f2f2f2",
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    cursor: "pointer"
  },

  modalForm: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },

  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "24px"
  },

  cancelBtn: {
    background: "#ccc",
    color: "#000",
    border: "none",
    padding: "12px 18px",
    borderRadius: "10px",
    cursor: "pointer"
  },

  updateBtn: {
    background: "#000",
    color: "#fff",
    border: "none",
    padding: "12px 18px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600"
  }

};

export default AdminProducts;